import { Banner, Heading } from '@mm/components';
import { PlusCircleIcon } from '@mm/icons';
import { UIFilterStarterKindType } from '@mm/state/model/ChatStarterModel';
import classNames from 'classnames';
import React from 'react';
import {
  ButtonColor,
  PrimaryButton,
} from '../../../../../../common/buttons/PrimaryButton/PrimaryButton';
import { trackWebAppGAEvent } from '../../../../../../common/helpers/plugins/website-google-analytics';
import { CreateChatStarterButton } from '../CreateChatStarterButton/CreateChatStarterButton';
import { starterTypeByKind } from '../types';
import { useCreateChatStarter } from '../use-create-chat-starter';
import styles from './ChatStartersEmptyState.module.css';

type Props = {
  className?: string;
  starterKind: UIFilterStarterKindType;
  createDisabled: boolean;
};

export const ChatStartersEmptyState = ({
  className,
  starterKind,
  createDisabled,
}: Props) => {
  const { createChatStarter } = useCreateChatStarter();

  const starter = starterTypeByKind[starterKind];
  const name = starterKind === 'all' ? 'Chat Starters' : starter.name;

  const { icon: Icon, emptyStateBanner } = starter;

  if (emptyStateBanner) {
    const { imageUrl, ...bannerProps } = emptyStateBanner;
    const onSubmitButtonClick = () => {
      trackWebAppGAEvent('click', {
        category: 'create_starter',
        label: `create_button_${starterKind}`,
      });
      createChatStarter(starterKind);
    };

    return (
      <Banner
        css={{
          container: styles.banner,
          content: styles.banner_container,
          left: styles.banner_check_area_container,
          header: styles.banner_header,
        }}
        {...bannerProps}
        button={
          <PrimaryButton
            color={ButtonColor.green}
            leftIcon={<PlusCircleIcon color="#fff" />}
            onClick={onSubmitButtonClick}
          >
            {bannerProps.submitButtonText}
          </PrimaryButton>
        }
      >
        <img src={imageUrl} />
      </Banner>
    );
  }
  return (
    <div className={classNames(className, styles.container)}>
      <div className={styles.icon_container}>
        <Icon className={styles.icon} color="#e7e7e9" />
      </div>
      <Heading
        size={6}
        className={styles.text}
        text={`You do not have ${name} created yet`}
      />
      <CreateChatStarterButton
        starterKind={starterKind}
        disabled={createDisabled}
        withPlusIcon
      />
    </div>
  );
};
